/**
 * HelpableFeedChip - the small "you can help" marker a live event's helpable
 * posts wear in the event feed and the space feed (Track 2 Phase A, spec 3.1 /
 * P4 / P11). It is the passive feed counterpart to the ForYouSection cards: a
 * post whose id is one of the viewer's judged matches at the live event wears
 * this so the same truth reads in the main list, no reordering.
 *
 * Reuses the helpable-green chip family the LivePill count chip and the
 * ForYouSection header established - the exact "/I Can Help.svg" asset + green
 * outline - so it introduces NO new element type (spec 3.1). Icon-led: the
 * decorative asset leads, the words "you can help" carry the meaning (locked
 * copy, spec section 4; Stuart gate in-PR). `shrink-0` keeps it whole in the
 * card byline while the space/topic/time segments yield first. The words are
 * real text, so assistive tech and 200%-zoom readers get the label for free
 * (spec 3.6) - no sr-only needed (unlike the pill, whose chip is a bare count).
 */
export function HelpableFeedChip() {
  return (
    <span className="inline-flex shrink-0 items-center gap-1 rounded-full border border-green-200 bg-green-50 px-1.5 py-0.5 text-xs font-semibold text-green-700">
      <img src="/I Can Help.svg" alt="" aria-hidden="true" className="h-3.5 w-3.5" />
      you can help
    </span>
  );
}
